export default function getDomainsReducer
    (state = { error:null, success:null, processing:false }, action) {

    switch (action.type)
    {
        case 'GET_DOMAINS_SUCCESS':
            return {...state, ...{success: action.success }};

        case 'GET_DOMAINS_ERROR':
            return {...state, ...{ error: action.error }};

        case 'GET_DOMAINS_PROCESSING':
            return {...state, ...{ processing: action.processing }};

        default: return state;
    }
}